import React, { useEffect } from "react";
import ClinicalNotesConsole from "./ClinicalNotesConsole";
import DiagnosisConsole from "./DiagnosisConsole";
import { useClinicStore } from "../../store/clinicStore";
import type { Diagnosis } from "../../types/domain";
import Button from "../common/Button";
import "./NotesAndDiagnosis.css";

interface NotesAndDiagnosisProps {
    visitId: string | number;
    patientId: string | number;
    isLocked?: boolean;
}

export default function NotesAndDiagnosis({ visitId, patientId, isLocked = false }: NotesAndDiagnosisProps) {
    const { sessionDiagnoses, setSessionDiagnoses } = useClinicStore();

    // If we had a backend for diagnoses, we would load them here or in Doctor.tsx
    // For now, sessionDiagnoses is our source of truth for the session.

    const handleAddDiagnosis = (diagnosis: Diagnosis) => {
        setSessionDiagnoses([...sessionDiagnoses, diagnosis]);
    };

    const handleRemoveDiagnosis = (id: number) => {
        setSessionDiagnoses(sessionDiagnoses.filter(d => d.id !== id));
    };

    return (
        <div className="notes-diagnosis-shell">
            <div className="notes-diagnosis-layout">
                <div className="layout-column notes-column">
                    <ClinicalNotesConsole
                        visitId={visitId}
                        patientId={patientId}
                        isLocked={isLocked}
                    />
                </div>
                <div className="layout-column diagnosis-column">
                    <DiagnosisConsole
                        visitId={visitId}
                        isLocked={isLocked}
                        selectedDiagnoses={sessionDiagnoses}
                        onAdd={handleAddDiagnosis}
                        onRemove={handleRemoveDiagnosis}
                    />
                </div>
            </div>

            {/* Combined save button */}
            <div className="combined-save-area">
                <Button
                    variant="primary"
                    size="lg"
                    disabled={isLocked}
                    className="btn-save-combined"
                    title="Save clinical notes and diagnoses"
                >
                    💾 Save All Changes
                </Button>
            </div>
        </div>
    );
}
